const getAppOptionValue = (optionValue) => {
  switch (optionValue) {
    case 'YES':
    case 'TRUE':
      return true;

    case 'NO':
    case 'FALSE':
      return false;

    default:
      return optionValue;
  }
};

export const preprocessAppOptions = (appOptions) => {
  const preprocessedOptions = {
    keepUserSpecifiedDocEffectiveDate: appOptions.KeepUserSpecifiedDocEffectiveDate,
    doNotActivateRolesOnActivateofActor: appOptions.DoNotActivateRolesOnActivateofActor,
    certifyOnFulfilledRequirements: appOptions.CERTIFY_ON_FULFILLED_REQUIREMENTS,
    applyLastObtaindateForCertifyOnRevision:
      appOptions.APPLY_LAST_OBTAINDATE_FOR_CERTIFY_ON_REVISION,
    mandateCertificationForRole: appOptions.MandateCertificationForRole,
    synchronizeFunctionalManagertoPersonManager:
      appOptions.SynchronizeFunctionalManagertoPersonManager,
    recordDocumentContentAccessHistory: appOptions.RecordDocumentContentAccessHistory,
    traceEnabled: appOptions.TraceEnabled,
    saveRecentEvents: appOptions.SaveRecentEvents,
    enableTimeZoneAtDocumentLevel: appOptions.EnableTimeZoneAtDocumentLevel,
    enableExternalUserLogin: appOptions.EnableExternalUserLogin,
    externalUserNeedsApproval: appOptions.ExternalUserNeedsApproval,
    addEscapeCharacterForDash: appOptions.AddEscapeCharacterForDash,
    allowDocumentReleaseWithPendingRequirementProcessing:
      appOptions.AllowDocumentReleaseWithPendingRequirementProcessing,
    allowEnhancedGlobalSearch: appOptions.EnhancedGlobalSearchWithAdvancedSearchCriteria,
    adverseEventCodesforFDA: appOptions.AdverseEventCodesforFDA,
  };

  for (const key in preprocessedOptions) {
    preprocessedOptions[key] = getAppOptionValue(preprocessedOptions[key]);
  }

  return preprocessedOptions;
};
